export const giftTemplateData = item => [
  {
    replaceValue: '__CODE__',
    value: item.code ? item.code : '',
  },
  {
    replaceValue: '__NAME__',
    value: item.name ? item.name : '',
  },
  {
    replaceValue: '__SHOW_ACTION__',
    value: item.showAction ? item.showAction : '',
  },
  {
    replaceValue: '__STOCK__',
    value: item.stock ? item.stock : '',
  },
  {
    replaceValue: '__PRICE__',
    value: item.price ? item.price : '',
  },
  {
    replaceValue: '__PRICE_WITH_DISCOUNT__',
    value: !item.priceWithoutDiscount ? item.price : item.priceWithoutDiscount,
  },
  {
    replaceValue: '__AVAILABILITY__',
    value: item.availability ? item.availability : '',
  },
];

export const campaignTemplateData = item => {
  let fullDate = '-';

  if (item.publishDate) {
    const date = new Date(item.publishDate.date);
    fullDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
  }

  return [
    {
      replaceValue: '__CODE__',
      value: item.code ? item.code : '',
    },
    {
      replaceValue: '__SHOW_ACTION__',
      value: item.showAction ? item.showAction : '',
    },
    {
      replaceValue: '__TITLE__',
      value: item.title ? item.title : '',
    },
    {
      replaceValue: '__PUBLISH_DATE__',
      value: fullDate,
    },
  ];
};

export const bannersTemplateData = item => [
  {
    replaceValue: '__ID__',
    value: item.id ? item.id : '',
  },
  {
    replaceValue: '__TITLE__',
    value: item.title ? item.title : '',
  },
  {
    replaceValue: '__VALID_FROM__',
    value: item.validFrom ? item.validFrom : '',
  },
  {
    replaceValue: '__VALID_TILL__',
    value: item.validTill ? item.validTill : '',
  },
  {
    replaceValue: '__IMAGE__',
    value: item.image ? item.image : '',
  },
  {
    replaceValue: '__BEFORE_LOGIN__',
    value: item.accessibleBeforeLogin ? 'Yes' : 'No',
  },
  {
    replaceValue: '__AFTER_LOGIN__',
    value: item.accessibleAfterLogin ? 'Yes' : 'No',
  },
  {
    replaceValue: '__VISIBLE_TO_SEGMENTS__',
    value: item.visibleToSegmentsOnly ? 'Yes' : 'No',
  },
];
